export default {
    namespaced: true,
    state: {
        item: {},
        loadedUsf: [],
        loadMore: false
    },
    mutations: {
        setLoadedUsf(state, payload) {
            state.loadedUsf = payload.items;
            state.loadMore = payload.loadMore;
        },
        loadMoreUsf(state, payload){
            state.loadMore = payload.loadMore;
            for(let i =0; i < payload.items.length; i++){
                state.loadedUsf.push(payload.items[i])
            }
        },
        clearItems(state){
            state.loadedUsf = [];
        },
        loadItem(state, data){
            state.item = data;
        },
        clearItem(state){
            state.item = {};
        },
    },
    actions: {
        loadUsf({commit}, json) {
            commit('setLoadedUsf', json);
        },
        loadMore(store, data){
            store.commit('loadMoreUsf', data);
        },
        loadItem(store, data){
            store.commit('clearItem');
            store.commit('loadItem', data);
        },
        clearItems(store) {
            store.commit('clearItem');
        }
    },
    getters: {
        loadedUsf(state) {
            return state.loadedUsf;
        },
        item(state){
            return state.item;
        },
        loadedSingleUsf(state) {
            return usfId => {
                return state.loadedUsf.find(usfOnce => {
                    return usfOnce.title === usfId;
                })
            }
        },
        loadMoreBtn(state){
            return state.loadMore;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/Usf/usfStore.js